// auth.keys.ts
import { LoginPayload } from '../model';

export const authKeys = {
  all: ['auth'] as const,
  login: (payload: LoginPayload) => [...authKeys.all, 'login', payload] as const,
  logout: () => [...authKeys.all, 'logout'] as const,
  forgotPassword: (email: string) => [...authKeys.all, 'forgot-password', email] as const,
  resetPassword: (token: string) => [...authKeys.all, 'reset-password', token] as const,
};
